// extracted by mini-css-extract-plugin
module.exports = {"headerIcon":"general_headerIcon_1Waax","generalCard":"general_generalCard_2LMA-","rightTable":"general_rightTable_2XtqR","titleBig":"general_titleBig_Qmaj5"};